export default __webpack_public_path__ + "static/media/ai_computer.43610d6d.svg";